import { render, staticRenderFns } from "./AllBDR.vue?vue&type=template&id=4c662065"
import script from "./AllBDR.vue?vue&type=script&lang=js"
export * from "./AllBDR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports